export const EXPERIENCE_DATA = [
  {
    company: 'NYU VIDA Lab',
    roles: [
      {
        title: 'ML Engineer - Computer Vision - Graduate Research Assistant',
        period: 'May 2025 - Present',
        narrative:
          'Improved the multimodal ingestion pipeline across heterogeneous data sources, reducing manual feature extraction by 70 percent. Engineered drift-detection models using segmentation comparison across temporal data, reaching 85 percent accuracy, and designed cross-source feature alignment across six data modalities to cut reconciliation time from days to four hours.',
        skills: ['Computer Vision', 'Segmentation', 'Multimodal Systems', 'Feature Alignment'],
      },
      {
        title: 'Data Engineer, Multimodal Datasets / Software Engineer, Real-Time Systems - Graduate Research Assistant',
        period: 'May 2025 - Present',
        narrative:
          'Built the real-time LiDAR, audio, and video ingestion pipeline for multimodal urban datasets. Improved cross-modal alignment to under 50 milliseconds, removed drift artifacts, and designed a modular REIP pipeline that cut per-run setup by roughly 90 percent while standardizing formats across collection sessions.',
        skills: ['LiDAR', 'Audio/Video Sync', 'REIP', 'Multimodal Datasets'],
      },
    ],
  },
  {
    company: 'Tiny Archives',
    roles: [
      {
        title: 'Software Developer Intern',
        period: 'Jun 2025 - Aug 2025',
        narrative:
          'Architected a secure, scalable archival platform with Next.js, Python, and PostgreSQL to support dozens of terabytes of long-term data. Implemented client-side AES-256 encryption and optimized hierarchical PostgreSQL search to reduce query latency by about 92 percent.',
        skills: ['Next.js', 'Python', 'PostgreSQL', 'Encryption'],
      },
    ],
  },
  {
    company: 'Kaleris',
    roles: [
      {
        title: 'Software Engineer',
        period: 'Jan 2022 - Aug 2024',
        narrative:
          'Engineered Kafka and WebSocket real-time layers plus API integrations, reducing polling traffic and improving latency. Built a Vue and Spring Boot GenAI assistant over 10,000-plus documentation pages and took ownership of backend operations, leading to promotion from Associate Software Engineer.',
        skills: ['Kafka', 'WebSockets', 'Vue', 'Spring Boot', 'GenAI'],
      },
    ],
  },
  {
    company: 'Caterpillar',
    roles: [
      {
        title: 'Mobile App Developer Intern',
        period: 'Jun 2021 - Dec 2021',
        narrative:
          'Built mobile applications for iOS and Android using Angular and Ionic. Implemented background download functionality and resolved cross-platform compatibility issues across devices, improving the reliability of the mobile workflow.',
        skills: ['Angular', 'Ionic', 'iOS', 'Android'],
      },
    ],
  },
];
